import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Transcript = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase
    viewBox='0 0 24 24'
    role='presentation'
    data-testid='transcript-icon'
    {...rest}
  >
    {type === 'stroke' ? (
      <path
        d='M6.756 15.25h4.5m3.5 0h2.5m-10.5-4h1.5m3.5 0h5.5m-12.5-6.5h14.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2h-14.5a2 2 0 0 1-2-2V6.75a2 2 0 0 1 2-2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.006 6.75A2.75 2.75 0 0 1 4.756 4h14.5a2.75 2.75 0 0 1 2.75 2.75v10.5a2.75 2.75 0 0 1-2.75 2.75h-14.5a2.75 2.75 0 0 1-2.75-2.75zm4 8.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m9 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m-8.25-4.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm5 0a.75.75 0 1 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
